// Use the hostname so local diagnostics also work in production builds.
export function isPreviewHost(): boolean {
  if (typeof window === "undefined") return false;

  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}

export function buildCommit(): string | null {
  const sha = process.env.NEXT_PUBLIC_GIT_COMMIT;
  return sha ? sha.slice(0, 7) : null;
}
